const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
        twoFactor: {
          instruction: "Digite o código de verificação do seu aplicativo autenticador",
          code: "Código de verificação",
          verify: "Verificar",
          back: "Voltar ao login",
        },
        deviceConfirm: {
          instruction: "Detectamos um novo dispositivo. Enviamos um código para o seu e-mail. Digite-o abaixo para continuar.",
          code: "Código de confirmação",
          verify: "Confirmar dispositivo",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
          expired: "Sua assinatura venceu em {{date}}. Regularize o pagamento para voltar a usar o sistema.",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova conexão",
        restartConnections: "Reiniciar",
        callSupport: "Suporte",
        transferTickets: "Transferir tickets",
        allOperational: "Todas as conexões operando",
        needsAttention: "conexão precisa de atenção",
        needAttention: "conexões precisam de atenção",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",
        webhookNaoConfirmado: "Recebimento não confirmado",
        reverificarWebhook: "Verificar novamente",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
          oficialError: {
            title: "Conexão não registrada na API Oficial",
            content:
              "O cadastro na API Oficial do WhatsApp não foi concluído. Exclua esta conexão e crie novamente; se o erro persistir, verifique se o serviço da API Oficial está no ar",
          },
        },
        table: {
          channel: "Canal",
          name: "Nome",
          status: "Status",
          lastUpdate: "Atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número",
          color: "Cor",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: { header: "Histórico do ticket" },
        loading: "Carregando…",
        summary: "{{events}} eventos · {{access}} acessos",
        empty: "Nenhum evento registrado para este ticket.",
        showAccess: "Mostrar acessos",
        close: "Fechar",
        kinds: { transfered: "transferências", pending: "devoluções", closed: "encerramentos", reopen: "reaberturas" },
        // frases dos eventos vivem em components/ShowTicketLogModal/ticketLogRules.js
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      whatsappOficialWizard: {
        title: "Conectar WhatsApp API Oficial",
        steps: {
          credenciais: "Credenciais",
          numero: "Número",
          webhook: "Webhook",
          identificacao: "Identificação",
          conclusao: "Conclusão",
        },
        credenciais: {
          titulo: "Vamos conectar com a Meta",
          descricao:
            "Informe o token de acesso do seu usuário de sistema no Meta Business. Com ele o PULSE descobre sozinho a conta, o número e os identificadores.",
          token: "Token de acesso",
          comoGerar: "Como gerar este token",
          passos:
            "No Meta Business: Configurações do negócio → Usuários do sistema → selecione o usuário → Gerar novo token → escolha o app → marque as permissões business_management, whatsapp_business_messaging e whatsapp_business_management (business_management é uma permissão separada, sem ela o wizard não lista as contas WhatsApp) → Gerar token. Use o token permanente de usuário de sistema, não o token de teste (expira em 24h).",
          businessIdManual: "ID do negócio",
          businessIdAjuda:
            "Encontre em Meta Business → Configurações do negócio → Informações do negócio. Deixe em branco se preferir que a gente tente descobrir sozinho.",
          businessIdObrigatorio:
            "Não conseguimos descobrir o negócio a partir deste token — isso é comum com token de usuário de sistema. Informe o ID do negócio para continuar.",
        },
        numero: {
          titulo: "Qual número vai usar esse canal?",
          negocio: "Conta de negócio",
          waba: "Conta WhatsApp Business",
          numero: "Número",
          semNumeros: "Esta conta não tem nenhum número cadastrado na Meta.",
          qualidade: "Qualidade",
          verificado: "Verificado",
          naoVerificado: "Não verificado",
          verificacao: "Verificação",
          verificacaoExpirada: "Código de verificação expirado",
        },
        webhook: {
          titulo: "Pra receber mensagens",
          descricao:
            "A Meta precisa saber para onde enviar as mensagens recebidas. O PULSE pode configurar isso pra você.",
          automatico: "Configurar automaticamente",
          appId: "ID do app",
          appSecret: "Chave secreta do app",
          configurar: "Configurar webhook",
          manual: "Ou configure manualmente no painel da Meta",
          url: "URL de callback",
          verifyToken: "Token de verificação",
          copiar: "Copiar",
          copiado: "Copiado!",
          verificar: "Verificar",
          verificado: "Webhook confirmado",
          naoVerificado: "Webhook ainda não confirmado",
          aguardandoMensagem: "Aguardando a primeira mensagem para confirmar",
          pular: "Pular por enquanto",
        },
        identificacao: {
          titulo: "Como esse canal aparece pra sua equipe",
          nome: "Nome da conexão",
          nomeAjuda: "Esse nome só aparece para a sua equipe.",
          fila: "Fila padrão",
          vertical: "Tipo de negócio",
          verticalAjuda: "Aparece para seus clientes no perfil do WhatsApp.",
        },
        conclusao: {
          titulo: "Tudo pronto",
          testando: "Enviando mensagem de teste...",
          testeOk: "Mensagem de teste enviada com sucesso.",
          testeFalhou: "A mensagem de teste falhou:",
          resumo: "Resumo da conexão",
          abrirConfiguracoes: "Abrir configurações do canal",
          verConexoes: "Ver conexões",
        },
        botoes: {
          voltar: "Voltar",
          continuar: "Continuar",
          concluir: "Concluir",
          cancelar: "Cancelar",
        },
        verticais: {
          AUTO: "Automotivo",
          BEAUTY: "Beleza, spa e salão",
          EDU: "Educação",
          ENTERTAIN: "Entretenimento",
          FINANCE: "Finanças e banco",
          GOVT: "Governo",
          HOTEL: "Hotelaria e hospedagem",
          GROCERY: "Mercado / supermercado",
          NONPROFIT: "Organização sem fins lucrativos",
          EVENT_PLAN: "Planejamento de eventos",
          RESTAURANT: "Restaurante",
          HEALTH: "Médico e saúde",
          PROF_SERVICES: "Serviços profissionais",
          RETAIL: "Compras e varejo",
          APPAREL: "Roupas e vestuário",
          TRAVEL: "Viagem e transporte",
          OTHER: "Outro",
        },
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
          blocked: "Contato bloqueado.",
          unblocked: "Contato desbloqueado.",
        },
        confirm: {
          blockTitle: "Bloquear {{name}}?",
          blockText: "O contato não poderá enviar nem receber mensagens até ser desbloqueado.",
          block: "Bloquear",
          unblockTitle: "Desbloquear {{name}}?",
          unblockText: "O contato volta a enviar e receber mensagens normalmente.",
          unblock: "Desbloquear",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Novo contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
          number: "WhatsApp",
          status: "Status",
          showing: "Mostrando {{shown}} de {{total}}",
          selected: "{{count}} selecionado(s)",
          tags: "Tags",
          search: "Buscar contato…",
        },
        menu: {
          importexport: "Importar / Exportar",
          importSection: "Importar",
          exportSection: "Exportar",
          importYourPhone: "Da agenda do WhatsApp",
          importYourPhoneDesc: "Contatos salvos no aparelho conectado",
          importToExcel: "De planilha (XLSX / CSV)",
          importToExcelDesc: "Mapeie colunas e aplique tags",
          importChats: "Dos chats existentes",
          importChatsDesc: "Cria contatos a partir das conversas",
          exportSheet: "Exportar planilha",
          exportSheetDesc: "Todos os {{count}} contatos · XLSX",
          deleteAll: "Excluir todos os contatos",
        },
        bulk: {
          selected: "{{count}} contatos selecionados",
          selectedAll: "Todos os {{count}} contatos selecionados",
          addTag: "Adicionar tag",
          assignWallet: "Atribuir carteira",
          deleteSelected: "Excluir selecionados",
          modeAdd: "Adicionar às tags",
          modeRemove: "Remover das tags",
          noTags: "Nenhuma tag cadastrada.",
          tagsAdded: "Tags aplicadas a {{count}} contato(s).",
          tagsRemoved: "Tags removidas de {{count}} contato(s).",
          walletUser: "Responsável",
          walletNone: "Sem responsável (remover carteira)",
          walletQueue: "Fila",
          walletQueueAuto: "Automática (uma fila do atendente)",
          walletHint: "Substitui a carteira atual dos contatos selecionados.",
          walletAssigned: "Carteira atribuída a {{count}} contato(s).",
          walletCleared: "Carteira removida de {{count}} contato(s).",
          cancel: "Cancelar",
          apply: "Aplicar",
        },
        pagination: {
          showing: "Mostrando {{shown}} de {{total}}",
          prev: "Página anterior",
          next: "Próxima página",
        },
        confirmDelete: {
          oneTitle: "Excluir {{name}}?",
          manyTitle: "Excluir {{count}} contatos?",
          allTitle: "Excluir todos os {{count}} contatos?",
          text: "Os tickets e mensagens associados serão perdidos. Esta ação não pode ser desfeita.",
          confirm: "Excluir",
        },
        exporting: "Gerando planilha…",
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
          agentName: "Nome do agente",
          tone: "Tom de voz",
          toneFormal: "Formal",
          toneAmigavel: "Amigável",
          toneDescontraido: "Descontraído",
          toneTecnico: "Técnico",
          useEmojis: "Usar emojis",
          restrictions: "Restrições do negócio",
          restrictionsHelp: "Regras que a IA nunca pode violar (ex.: não fale de preço)",
          transferInstructions: "Quando transferir para humano",
          transferInstructionsHelp: "Situações em que a IA deve passar para um atendente",
          transferMessage: "Mensagem de transferência",
          knowledgeText: "Base de conhecimento (texto)",
          model: "Modelo",
          promptBase: "Prompt base",
          preview: "Preview do system prompt",
        },
        tabs: {
          personality: "Personalidade",
          knowledge: "Conhecimento",
          advanced: "Avançado",
        },
        files: {
          title: "Arquivos de conhecimento",
          saveFirst: "Salve o agente para importar arquivos.",
          upload: "Importar arquivo",
          hint: "PDF, TXT ou DOCX — até 20 MB por arquivo, 20 arquivos por agente.",
          processing: "Processando",
          ready: "Pronto",
          failed: "Falhou",
          deleted: "Arquivo removido.",
          uploaded: "Arquivo enviado. O processamento continua em segundo plano.",
        },
        success: "Agente salvo com sucesso!",
        title: {
          add: "Adicionar Agente de IA",
          edit: "Editar Agente de IA",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Agente de IA",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          knowledge: "Conhecimento",
          knowledgeBadge: "Base de conhecimento",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
          wallet: "Carteira",
          walletPlaceholder: "Sem responsável",
          walletQueue: "Fila da carteira",
          walletQueuePlaceholder: "Selecione a fila",
          birthDate: "Data de nascimento",
          tags: "Tags",
          tagsPlaceholder: "Adicionar tag…",
          extraEmpty: "Nenhuma informação adicional.",
          chatbotTitle: "Desabilitar chatbot",
          chatbotOn: "O chatbot responde normalmente.",
          chatbotOff: "O chatbot não responde a este contato.",
          campaignsTitle: "Aceita campanhas",
          campaignsDesc: "Recebe disparos em massa",
          audioTitle: "Aceitar áudios",
          audioDesc: "Permite receber mensagens de voz deste contato.",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          addField: "Campo",
          block: "Bloquear",
          unblock: "Desbloquear",
          okAdd: "Adicionar contato",
          okEdit: "Salvar alterações",
          cancel: "Cancelar",
        },
        subtitleAdd: "Preencha os dados para cadastrar um novo contato",
        createdAt: "criado em",
        photoHint: "A foto vem do WhatsApp do contato",
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver fluxos",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
          security: "Segurança",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        subtitle: {
          default: "A mensagem será enviada automaticamente na data programada",
          sent: "Enviada em {{date}}",
        },
        tools: {
          quickMessages: "Respostas rápidas",
          quickMessagesSearch: "Buscar resposta rápida…",
          quickMessagesEmpty: "Nenhuma resposta rápida encontrada",
          variables: "Variáveis",
          attach: "Anexar",
        },
        recurrence: {
          subtitle: "Repetir este envio automaticamente",
          every: "A cada",
          repeat: "Repetir",
          times: "vezes",
          weekendNormal: "Fim de semana: enviar normalmente",
          weekendBefore: "Fim de semana: um dia útil antes",
          weekendAfter: "Fim de semana: um dia útil depois",
        },
        failure: {
          title: "Falha no último envio",
          unknown: "O envio falhou, mas o motivo não foi registrado.",
        },
        template: {
          title: "Template aprovado (WhatsApp Oficial)",
          subtitle: "Escolha o modelo que a Meta vai entregar no horário agendado",
          select: "Escolher template",
          placeholder: "Nenhum template selecionado",
          none: "Sem template",
          paramLabel: "Valor de {{token}}",
          paramHelper: "Texto fixo ou {nome}, {numero}, {email} — resolvidos pelo contato no envio",
          preview: "Prévia",
          incomplete: "Preencha todas as variáveis do template.",
          windowHint:
            "Sem template, o envio só funciona se o contato tiver escrito nas últimas 24 horas. Fora dessa janela a Meta exige um template aprovado.",
          emptySync:
            "Nenhum template aprovado nesta conexão. Sincronize os templates na tela de Conexões.",
          emptyIneligible:
            "Esta conexão tem {{count}} template(s) aprovado(s), mas nenhum pode ser usado aqui: todos exigem mídia no cabeçalho ou botão com URL variável.",
          // Sem chaves duplas no texto: o i18next as trataria como
          // interpolação e o usuário veria a frase com buracos.
          mixed:
            "Este template mistura variáveis numeradas com variáveis nomeadas no mesmo corpo. Ajuste na Meta e sincronize novamente.",
        },
        reminder: {
          title: "Lembrete (opcional)",
          description: "substitui o horário original do envio",
          set: "Definir lembrete",
          remove: "Remover",
        },
        footer: {
          nextSend: "Próximo envio",
          then: "depois",
        },
        confirmationModal: {
          deleteTitle: "Remover anexo?",
          deleteMessage: "O arquivo será removido deste agendamento.",
        },
        toasts: {
          deleted: "Anexo removido com sucesso.",
        },
        title: {
          error: "Erro de envio",
          add: "Novo agendamento",
          edit: "Editar agendamento",
          message: "Mensagem",
        },
        form: {
          contactPlaceholder: "Selecione o contato",
          canal: "Canal",
          bodySms: "Mensagem SMS",
          bodyPlaceholder: "Escreva a mensagem…",
          smsCount: "{{chars}} caracteres — {{parts}} SMS",
          smsAttachmentWarning: "Este agendamento tem um anexo — remova-o antes de usar SMS.",
          fromQuickMessage: "Da resposta rápida",
          connection: "Conexão",
          connectionPlaceholder: "Selecione a conexão",
          openTicket: "Abrir ticket ao enviar",
          ticketFor: "Para",
          ticketQueue: "fila",
          ticketOff: "Nenhum ticket será aberto",
          ticketUser: "Atendente",
          ticketUserPlaceholder: "Selecione o atendente",
          ticketQueueLabel: "Fila",
          ticketQueuePlaceholder: "Selecione a fila",
          statusTicket: "Status do ticket",
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de envio",
          sentAt: "Data de envio",
          assinar: "Enviar assinatura",
        },
        buttons: {
          removeAttachment: "Remover anexo",
          okAdd: "Agendar envio",
          okEdit: "Salvar alterações",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova tag",
          edit: "Editar tag",
          addKanban: "Nova Coluna",
          editKanban: "Editar Coluna",
        },
        subtitleAdd: "Etiqueta para contatos e tickets",
        usedIn: "Usada em {{contacts}} contatos e {{tickets}} tickets",
        previewEmpty: "Prévia",
        nameShort: "O nome precisa ter ao menos 3 caracteres.",
        fileTooBig: "Arquivo {{name}} é muito grande. Máximo: 10MB.",
        fileType: "Tipo de arquivo {{type}} não é suportado.",
        form: {
          name: "Nome",
          namePlaceholder: "Ex.: Em negociação",
          preview: "Prévia",
          color: "Cor",
          customColor: "Cor personalizada",
          kanbanTitle: "Usar como coluna do Kanban",
          kanbanDesc: "Tickets com esta tag aparecem em uma lane própria",
          timeLane: "Alerta de tempo na lane",
          onTimeout: "Ao estourar o tempo",
          highlight: "Destacar card",
          moveTo: "Mover para {{lane}}",
          rollbackLaneId: "Voltar para a lane (ao retomar)",
          none: "Nenhuma",
          greetingMessageLane: "Mensagem ao mover para esta coluna",
          optional: "opcional",
          greetingPlaceholder: "Olá {nome}! Sua proposta está em análise…",
          attach: "Anexar mídia",
          nextLaneId: "Coluna de destino",
          mediaFiles: "Mídia",
          recurrence: "Recorrência",
          recurrenceDesc: "Reaplicar a tag automaticamente após um período",
        },
        buttons: {
          okAdd: "Criar tag",
          okEdit: "Salvar alterações",
          cancel: "Cancelar",
          delete: "Excluir tag",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Coluna salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
        all: "Todas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimentos e mensagens…",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        naoEntregue: "Não entregue",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Iniciar atendimento",
        subtitle: "Abre um novo ticket para o contato",
        fieldLabel: "Contato",
        searchPlaceholder: "Digite ao menos 3 letras para buscar…",
        change: "Trocar",
        queue: "Fila",
        connection: "Conexão",
        selectQueue: "Selecione uma fila",
        selectConnection: "Selecione uma conexão",
        assignTo: "Atribuir a",
        me: "Mim",
        openTicket: "Ticket #{{id}} aberto",
        openBy: "Atendido por",
        greetingTitle: "Enviar saudação ao abrir",
        greetingDesc: "Envia uma resposta rápida como primeira mensagem",
        greetingUses: "Usa a resposta rápida",
        greetingPick: "Escolha a resposta rápida…",
        add: "Adicionar",
        buttons: {
          ok: "Abrir atendimento",
          cancel: "Cancelar",
        },
      },
      contactImport: {
        title: "Importar contatos",
        step: "Etapa {{n}} de {{total}}",
        dropTitle: "Arraste a planilha ou clique para escolher",
        dropText: "XLSX, XLS ou CSV · primeira linha com o nome das colunas",
        invalidFile: "Arquivo inválido. Use .xls, .xlsx ou .csv.",
        fileMeta: "{{rows}} linhas · {{cols}} colunas detectadas",
        changeFile: "Trocar arquivo",
        colSheet: "Coluna da planilha",
        colSample: "Exemplo",
        colField: "Campo no Pulse",
        skipColumn: "Ignorar coluna",
        updateTitle: "Atualizar existentes",
        updateDesc: "Mesmo número: sobrescreve os dados",
        extraField: "Info extra",
        validateTitle: "Validar no WhatsApp",
        validateDesc: "Confere o número antes de criar",
        applyTag: "Aplicar tag",
        noTag: "Nenhuma",
        missing: "Mapeie os campos obrigatórios: {{fields}}",
        invalidLines: "{{count}} linha(s) com número inválido serão ignoradas.",
        showLines: "Ver linhas",
        hideLines: "Ocultar",
        downloadModel: "Baixar modelo",
        cancel: "Cancelar",
        back: "Voltar",
        importCount: "Importar {{count}} contatos",
        close: "Fechar",
        startedTitle: "Importação em segundo plano",
        startedText: "{{count}} contatos foram enviados e estão sendo criados em segundo plano ({{ignored}} linhas ignoradas). Você receberá uma notificação quando terminar; pode fechar esta janela.",
        progressTitle: "Importando contatos…",
        progressHint: "Pode fechar esta janela: a importação continua e você será notificado ao terminar.",
        counters: "{{criados}} novo(s) · {{ignorados}} já existia(m) · {{invalidos}} inválido(s)",
        doneTitle: "Importação concluída",
        doneText: "{{criados}} contato(s) criado(s), {{ignorados}} já existia(m), {{invalidos}} inválido(s). {{linhas}} linha(s) da planilha ficaram de fora por falta de nome ou número.",
        cancelTitle: "Importação cancelada",
        errorTitle: "A importação falhou",
      },
      smsModal: {
        title: "Enviar SMS",
        subtitle: "Mensagem de texto pelo provedor de SMS",
        balance: "Saldo: {{saldo}}",
        balanceAfter: "Saldo após envio {{saldo}}",
        message: "Mensagem",
        placeholder: "Digite o texto do SMS…",
        counter: "{{chars}} caracteres · {{sms}} SMS",
        hint: "Até 160 caracteres cabem em 1 SMS; acima disso cada 153 caracteres contam mais um.",
        emptyBody: "Informe o texto da mensagem.",
        sent: "SMS enviado com sucesso! {{fracoes}} fração(ões) debitada(s).",
        cancel: "Cancelar",
        send: "Enviar SMS",
      },
      contactImportPhone: {
        title: "Importar da agenda do WhatsApp",
        subtitle: "Traz os contatos salvos no aparelho conectado",
        titleChats: "Importar dos chats existentes",
        subtitleChats: "Cria contatos a partir das conversas da conexão",
        choose: "Escolha a conexão",
        empty: "Nenhuma conexão WhatsApp QR Code cadastrada.",
        connected: "Conectado",
        offline: "Conexão precisa estar conectada.",
        startedChats: "Importação dos chats iniciada em segundo plano. Você será avisado quando concluir.",
        noDuplicates: "Contatos já cadastrados não serão duplicados.",
        cancel: "Cancelar",
        import: "Importar contatos",
        started: "Importação da agenda iniciada em segundo plano. Você será avisado quando concluir.",
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel ao Vivo",
          tickets: "Conversas",
          quickMessages: "Respostas Rápidas",
          contacts: "Contatos",
          wallets: "Carteira",
          queues: "Filas & Chatbot",
          tags: "Tags & Campos",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Aniversários",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Assinatura",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          groupOperation: "Operação",
          groupAutomation: "Automação & Disparos",
          groupAdministration: "Administração",
          groupPlatform: "Plataforma",
          plans: "Planos",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
          connection: "Conexão",
          connectionNone: "Selecione uma conexão…",
          template: "Template (enviado no lugar da mensagem)",
          templateNone: "Nenhum — deixar o sistema escolher",
          templateHelper:
            "Com um template selecionado, ele é enviado dentro ou fora da janela de 24h e o campo Mensagem é descartado. Sem template, a mensagem vai como texto livre dentro da janela e, fora dela, o sistema escolhe um template aprovado.",
          templateMediaBadge: "mídia no cabeçalho",
          templateHeaderMediaUrl: "URL da mídia do cabeçalho",
          templateHeaderMediaUrlHelper:
            "Este template tem mídia no cabeçalho. Informe a URL pública do arquivo (imagem, vídeo ou documento); a Meta baixa desse link na hora do envio.",
          templateParamHelper:
            "Valor fixo ou {nome}, {numero}, {email} (dados do contato)",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        uses: "{{count}} usos",
        subtitleBefore: "Digite",
        subtitleAfter: "no atendimento para inserir",
        filters: {
          all: "Todas",
          team: "Da equipe",
          mine: "Minhas",
          media: "Com anexo",
        },
        view: {
          grid: "Grade",
          list: "Lista",
        },
        visibility: {
          team: "Equipe",
          personal: "Pessoal",
        },
        media: {
          image: "Imagem",
          audio: "Áudio",
          video: "Vídeo",
          pdf: "PDF",
          document: "Documento",
        },
        actions: {
          copy: "Copiar mensagem",
          edit: "Editar",
          delete: "Excluir",
        },
        title: "Respostas Rápidas",
        searchPlaceholder: "Buscar por atalho ou texto…",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteMediaTitle: "Remover anexo?",
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          save: "Salvar resposta",
          add: "Nova resposta",
          attach: "Anexar arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          copied: "Mensagem copiada.",
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          subtitle: "Crie um atalho para inserir mensagens prontas no atendimento",
          shortcodePlaceholder: "boleto",
          shortcodeHint: "Sem espaços ou acentos",
          shortcodeAvailable: "Atalho disponível · sem espaços ou acentos",
          shortcodeIssue: {
            spaces: "O atalho não pode ter espaços",
            accents: "O atalho não pode ter acentos ou caracteres especiais",
            taken: "Já existe uma resposta com este atalho",
          },
          messagePlaceholder: "Escreva a mensagem que será inserida no atendimento…",
          emoji: "Emoji",
          variables: "Variáveis",
          attachment: "Anexo (opcional)",
          attachmentHint: "Imagens, áudio, vídeo ou documentos até 20 MB",
          recordAudio: "Gravar áudio",
          recordedAudio: "Áudio gravado",
          newFile: "novo",
          removeAttachment: "Remover anexo",
          shareTitle: "Compartilhar com toda a equipe",
          shareOn: "Ligado: visível para todos os atendentes",
          shareOff: "Desligado: visível apenas para você",
          allowEdit: "Permitir que outros atendentes editem",
          oficialTitle: "Template oficial (WhatsApp Cloud API)",
          isStarter: "Template inicia conversa com o cliente",
          previewTitle: "Pré-visualização no chat",
          previewEmpty: "A mensagem aparecerá aqui…",
          previewInfo: "Variáveis substituídas com dados de exemplo",
          characters: "caracteres",
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Mensagem",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Nova resposta rápida",
          edit: "Editar resposta rápida",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        numberType: {
          landline: "Fixo",
          landlineHint:
            "Telefone fixo: ignorado em campanhas SMS, continua nas de WhatsApp.",
        },
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Colunas",
        },
      },

      campaigns: {
        smsEstimate: {
          landlineSkipped: "{{count}} contato fixo será ignorado no SMS (não recebe SMS e não consome crédito).",
          landlineSkipped_plural: "{{count}} contatos fixos serão ignorados no SMS (não recebem SMS e não consomem crédito).",
        },
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Campanhas",
          listContacts: "Listas",
          files: "Arquivos",
          settings: "Configurações",
        },
        settings: {
          sendWindowSection: "Janela de envio",
          startHour: "Início do envio",
          endHour: "Fim do envio",
          saturday: "Sábado",
          sunday: "Domingo",
          intervalsSection: "Intervalos",
          variablesSection: "Variáveis",
          savedToast: "Configurações salvas",
          discardTitle: "Descartar alterações?",
          discardMessage:
            "Há alterações não salvas. Ao fechar, elas serão perdidas.",
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
              campaignReport: {
          title: "Relatório de",
          inactive: "Inativa",
          scheduled: "Programada",
          process: "Em Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
          campaign: "Campanha",
          validContacts: "Contatos Válidos",
          confirmationsRequested: "Confirmações Solicitadas",
          confirmations: "Confirmações",
          deliver: "Entregues",
          connection: "Conexão",
          contactLists: "Lista de Contatos",
          schedule: "Agendamento",
          conclusion: "Conclusão",
          fetchError: "Erro ao buscar dados do relatório",
          backButton: "Voltar",
        },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Título",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Título",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
          workHours: "Expediente",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
          amountYearly: "Valor anual",
        },
        grid: {
          perMonth: "/mês",
          perYear: "/ano",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        subtitleWeek: "{{count}} envios programados para esta semana",
        searchPlaceholder: "Buscar agendamento…",
        showMore: "+{{count}} mais",
        canal: {
          label: "Canal",
          all: "Todos",
        },
        legend: {
          pend: "Programado",
          sent: "Enviado",
          rec: "Recorrente",
          err: "Falha",
          failedShort: "Falhou",
        },
        failureTooltip: "Motivo: {{reason}}",
        kpi: {
          thisWeek: "Esta semana",
          failed: "Falha de envio",
        },
        upcoming: {
          title: "Próximos envios",
          seeAgenda: "Ver agenda",
          empty: "Nenhum envio programado.",
        },
        actions: {
          edit: "Editar",
          delete: "Excluir",
        },
        recurrence: {
          every: {
            days: "Diário",
            weeks: "Semanal",
            months: "Mensal",
            minutes: "A cada minuto",
          },
          everyN: {
            days: "A cada {{count}} dias",
            weeks: "A cada {{count}} semanas",
            months: "A cada {{count}} meses",
            minutes: "A cada {{count}} min",
          },
        },
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        subtitle: "Etiquetas de contatos e tickets · {{kanban}} usadas no Kanban",
        search: "Buscar tag…",
        empty: "Nenhuma tag encontrada",
        showing: "Mostrando {{shown}} de {{total}}",
        addColumns: "+ ADICIONAR COLUNAS",
        seeTicket: "VER TICKET",
        filters: { all: "Todas", kanban: "Kanban", unused: "Sem uso" },
        table: {
          tag: "Tag",
          type: "Tipo",
          contacts: "Contatos",
          tickets: "Tickets",
          recurrence: "Recorrência",
          createdBy: "Criada por",
          actions: "Ações",
          kindKanban: "Kanban",
          kindContact: "Contato",
          timeAlert: "Alerta de tempo no Kanban",
          seeContacts: "Ver contatos",
          edit: "Editar",
          delete: "Excluir",
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
        },
        buttons: {
          add: "Nova tag",
          deleteAll: "Excluir todas",
        },
        confirmDelete: {
          titleBefore: "Excluir a tag",
          textBefore: "Ela será removida de",
          contacts: "contatos",
          and: "e",
          tickets: "tickets",
          textAfter: "Os contatos não são excluídos.",
          kanbanWarn: "Esta tag é uma coluna do Kanban — a lane será removida.",
          confirm: "Excluir tag",
        },
        confirmDeleteAll: {
          title: "Excluir todas as {{count}} tags?",
          text: "Todas as tags da empresa serão removidas de contatos e tickets, incluindo as colunas do Kanban. Esta ação não pode ser desfeita.",
          confirm: "Excluir todas",
        },
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Tag excluída com sucesso.",
          deletedAll: "{{count}} tag(s) excluída(s).",
        },
      },

      tagContacts: {
        total: "{{count}} contatos",
        filter: "Filtrar nesta lista…",
        empty: "Nenhum contato com esta tag.",
        showing: "Mostrando {{shown}} de {{total}}",
        seeAll: "Ver todos em Contatos →",
        remove: "Remover tag",
        removed: "Tag removida de {{name}}.",
      },

      tagsKanban: {
        title: "Colunas",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta coluna?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Coluna",
        },
        toasts: {
          deleted: "Coluna excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          smsPacks: "Pacotes SMS",
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
        },
        settings: {
          sections: {
            features: "Recursos",
            messages: "Mensagens personalizadas",
            lgpd: "LGPD",
            payments: "Pagamentos (super)",
            onboarding: "Assistente de onboarding (IA)",
          },
          payments: {
            mpPublicKey: "Mercado Pago · Public Key",
            pixDiscount: "Desconto no Pix (%)",
          },
          descriptions: {
            userRandom: "Distribui novos tickets entre os atendentes da fila de forma aleatória",
            acceptCallWhatsapp: "Responde à ligação avisando que só atende por mensagem",
            sendSignMessage: "O atendente escolhe se a assinatura vai em cada mensagem",
            sendGreetingMessageOneQueues: "Envia a saudação da fila mesmo quando há apenas uma",
            sendQueuePosition: "Informa ao contato a posição dele na fila de espera",
            sendFarewellWaitingTicket: "Envia a despedida também para tickets ainda em Aguardando",
            acceptAudioMessageContact: "Recebe áudios de qualquer contato, não só dos cadastrados",
            enableLGPD: "Ativa as regras de consentimento e anonimização de dados",
            requiredTag: "Exige ao menos uma tag para encerrar o atendimento",
            closeTicketOnTransfer: "Encerra o ticket atual ao transferi-lo para outra fila",
            showNotificationPending: "Notifica os atendentes quando há tickets pendentes",
            DirectTicketsToWallets: "Direciona tickets ao dono da carteira do contato",
            lgpdDeleteMessage: "Mensagens apagadas pelo contato ficam ofuscadas no histórico",
            lgpdConsent: "Pede consentimento a cada novo atendimento",
            lgpdHideNumber: "Atendentes veem o número do contato mascarado",
            onboarding: "Suporte por IA dentro do painel para esta empresa",
            onboardingProfiles: "Perfis com acesso",
          },
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            updateSuccess: "Operação atualizada com sucesso.",
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_",
            twoFactorPolicy: "Política de 2FA",
            twoFactorOptional: "Opcional",
            twoFactorMandatory: "Obrigatório",
            twoFactorDisabled: "Desativado"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        metaWindowNotice:
          "Você tem 24h para responder após receber uma mensagem, de acordo com as políticas da Meta.",
        header: {
          assignedTo: "Atribuído à:",
          aiActive: "IA ativa",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            pauseAI: "Pausar IA",
            resumeAI: "Reativar IA",
            integrationLabel: "Integração",
            integrationBlockedByBot:
              'A chave "Desabilitar chatbot" abaixo está ligada e silencia toda a automação deste contato, inclusive esta integração.',
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Vencimento",
          action: "Ação",
          status: "Status",
          period: "Período",
          method: "Meio",
          pay: "Pagar",
        },
        status: {
          paid: "Paga",
          overdue: "Vencida",
          open: "Em aberto",
          canceled: "Cancelada",
        },
      },
      versionControl: {
        title: "Uma atualização está disponível!",
        subtitle: "Clique em atualizar para obter as últimas melhorias.",
        update: "Atualizar",
        updating: "Atualizando...",
      },
      metaErrors: {
        notDelivered: "Não entregue",
        generic: "O WhatsApp recusou o envio desta mensagem",
        showDetails: "Ver detalhes",
        hideDetails: "Ocultar detalhes",
        technicalCode: "Código técnico",
        fixAt: "Regularizar no Meta Business",
        markResolved: "Já regularizei",
        markResolvedTitle: "Marcar o problema como regularizado?",
        markResolvedBody: "O aviso de problema na conta some desta conexão. Se a Meta voltar a recusar envios, ele reaparece sozinho.",
        markResolvedConfirm: "Sim, já regularizei",
        bannerTitle: "Problema na conta do WhatsApp Oficial",
        bannerDismiss: "Dispensar aviso de problema na conta",
        badge: {
          "131042": "Pagamento pendente na Meta",
          "131031": "Conta restrita na Meta",
          "131045": "Número não registrado",
          "133010": "Número não registrado",
          "368": "Conta restrita na Meta",
          "130497": "Envio restrito por país",
          "134011": "Termos de pagamento pendentes",
          "190": "Acesso à Meta expirado",
          default: "Problema na conta",
        },
        accountToast: "Problema na conta do WhatsApp: {{titulo}}",
        composerWarning: "Problema na conta desta conexão: {{titulo}}. Você ainda pode enviar, mas as mensagens podem não ser entregues.",
        failureLine: "Não entregue: {{titulo}}.",
        "131042": {
          title: "A conta do WhatsApp Business tem pagamento pendente na Meta",
          action: "Regularize no Meta Business para voltar a enviar",
        },
        "131031": {
          title: "A conta do WhatsApp Business foi restrita ou bloqueada pela Meta",
          action: "Abra o Gerenciador de Negócios da Meta e siga as instruções de verificação",
        },
        "131045": {
          title: "O número de telefone não está registrado na API oficial",
          action: "Refaça o registro do número na conexão do WhatsApp Oficial",
        },
        "133010": {
          title: "O número de telefone não está registrado na API oficial",
          action: "Refaça o registro do número na conexão do WhatsApp Oficial",
        },
        "368": {
          title: "A conta foi restrita pela Meta por violar políticas",
          action: "Veja os detalhes no Gerenciador de Negócios da Meta e peça a revisão",
        },
        "130497": {
          title: "A conta está restrita para enviar a contatos de alguns países",
          action: "Envie apenas a contatos de países permitidos ou fale com a Meta",
        },
        "134011": {
          title: "Os termos de pagamento da Meta estão pendentes de aceite",
          action: "Aceite os termos de pagamento no Meta Business para voltar a enviar",
        },
        "190": {
          title: "O acesso da conexão com a Meta expirou ou é inválido",
          action: "Reconecte o WhatsApp Oficial em Conexões para gerar um novo acesso",
        },
        "131047": {
          title: "Já se passaram mais de 24 horas desde a última resposta do cliente",
          action: "Envie um template aprovado para reabrir a conversa",
        },
        "131026": {
          title: "A mensagem não pôde ser entregue: o contato pode não ter WhatsApp, usar uma versão antiga do app ou não ter aceito os termos do WhatsApp",
          action: "Confirme o número com o contato e peça que atualize o WhatsApp",
        },
        "131050": {
          title: "O contato optou por não receber mensagens de marketing",
          action: "Não envie marketing a este contato; mensagens de atendimento continuam permitidas",
        },
        "130403": {
          title: "O contato bloqueou o seu número de empresa",
          action: "Não é possível enviar a este contato até que ele desbloqueie",
        },
        "131049": {
          title: "A Meta limitou mensagens de marketing para este contato",
          action: "Tente novamente mais tarde ou envie uma mensagem não promocional",
        },
        "131021": {
          title: "A mensagem foi enviada para o próprio número da empresa",
          action: "Informe o número do cliente como destinatário",
        },
        "132001": {
          title: "O template não existe ou não foi aprovado para este idioma",
          action: "Confira o nome e o idioma do template e se ele está aprovado na Meta",
        },
        "132015": {
          title: "O template está pausado por baixa qualidade",
          action: "Edite o template na Meta ou use outro aprovado",
        },
        "132016": {
          title: "O template foi desativado por baixa qualidade",
          action: "Crie um novo template e envie para aprovação",
        },
        category: {
          conta: {
            title: "A Meta recusou o envio por um problema na conta ou conexão",
            action: "Tente novamente em alguns minutos; se persistir, confira a conexão e a conta no Meta Business",
          },
          contato: {
            title: "A mensagem não pôde ser entregue a este contato",
            action: "Confira o número e se o contato pode receber esta mensagem",
          },
          janela: {
            title: "A janela de 24 horas da conversa está fechada",
            action: "Envie um template aprovado para reabrir a conversa",
          },
          template: {
            title: "O envio do template foi recusado pela Meta",
            action: "Confira as variáveis e o status do template na Meta",
          },
          limite: {
            title: "A Meta limitou os envios por volume ou qualidade",
            action: "Aguarde um pouco e reduza o ritmo dos envios",
          },
          midia: {
            title: "A Meta não aceitou o arquivo ou o tipo de mídia enviado",
            action: "Envie um arquivo em formato e tamanho aceitos pelo WhatsApp",
          },
        },
        unknown: {
          title: "A Meta não entregou a mensagem por um motivo não catalogado",
          action: "Veja o texto original da Meta nos detalhes técnicos",
        },
      },
      subscription: {
        page: {
          title: "Minha assinatura",
          smsBalance: "Saldo de créditos SMS:",
        },
        checkout: {
          titleNew: "Contratar plano",
          titleInvoice: "Pagar fatura",
          subtitleNew: "{{plan}} · ciclo começa hoje, {{date}}",
          subtitleInvoice: "Fatura de {{date}} · {{value}}",
          stepPlan: "Plano",
          stepPayment: "Pagamento",
          period: "Periodicidade",
          invoicePeriod: "Período da fatura",
          monthly: "Mensal",
          yearly: "Anual",
          perMonth: "/mês",
          perYear: "/ano",
          chargedOnDay: "Cobrado todo dia {{day}}",
          approxMonthly: "≈ {{value}} por mês",
          saveOneMonth: "Economize 1 mês",
          saveMonths: "Economize {{count}} meses",
          planSummary: "Resumo do plano",
          selected: "Selecionado",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
          lineMonthly: "{{plan}} · mensal",
          lineYearly: "{{plan}} · anual",
          installmentsRow: "Parcelamento no cartão",
          installmentsUpTo: "até {{label}}",
          installmentLabel: "{{n}}x de {{value}}",
          pixDiscountRow: "Desconto Pix ({{percent}}%)",
          total: "Total do ciclo",
          totalInvoice: "Total da fatura",
          cycleCardMonthly: "Renova automaticamente em {{date}} no mesmo cartão",
          cycleCardYearly: "Vale até {{date}}. Avisamos 5 dias antes da renovação.",
          cyclePix: "Próxima fatura em {{date}}. No Pix a renovação não é automática: avisamos 5 dias antes.",
          tabsLabel: "Forma de pagamento",
          tabCard: "Cartão",
          tabPix: "Pix",
          secure: "Dados do cartão vão direto para o Mercado Pago. O Pulse não armazena o número.",
          subscribe: "Assinar · {{value}}",
          payInvoice: "Pagar · {{value}}",
          generatePix: "Gerar Pix · {{value}}",
          terms: "Ao assinar você concorda com a renovação automática a cada ciclo. Cancele quando quiser em Assinatura › Plano atual.",
          pixHint: "Gere o código e pague pelo app do seu banco. A confirmação chega em segundos.",
          qrAlt: "QR Code do Pix",
          waitingPix: "Aguardando pagamento. A tela atualiza sozinha assim que o Pix for confirmado.",
          waitingCard: "Pagamento em análise pelo Mercado Pago. A tela atualiza sozinha assim que for confirmado.",
          waitingRecurring: "Aguardando a confirmação do Mercado Pago. A assinatura é ativada sozinha em instantes.",
          alreadyPaidQuestion: "Pagou e nada mudou em 2 minutos?",
          alreadyPaid: "Já paguei",
          stillPending: "Ainda não recebemos a confirmação. Aguarde mais alguns instantes.",
          paid: "Pagamento confirmado. Sua assinatura está ativa!",
          cardRejected: "Cartão recusado. Confira os dados ou use outro cartão.",
          cardUnavailable: "Pagamento com cartão indisponível no momento. Use o Pix.",
          cardLoadError: "Não foi possível carregar o formulário do cartão. Use o Pix ou tente de novo.",
          loadError: "Não foi possível carregar o checkout.",
          retry: "Tentar de novo",
          noPrice: "Este plano ainda não tem preço configurado. Fale com o suporte.",
          pageTitle: "Assinatura",
          licenseLabel: "Período de licença",
          licenseDueToday: "Sua licença vence hoje!",
          licenseDueIn: "Sua licença vence em {{days}} dias.",
          licenseExpired: "Sua licença está vencida. Regularize para voltar a usar o sistema.",
          billingEmail: "E-mail de cobrança",
          subscribeNow: "Assinar agora",
          adminOnlyNotice: "O acesso está suspenso até o pagamento da assinatura. Peça ao administrador da empresa para regularizar em Assinatura.",
        },
        card: {
          title: "Plano atual",
          status: {
            active: "Ativa",
            pastDue: "Em atraso",
            canceled: "Cancelada até {{date}}",
            pending: "Aguardando pagamento",
          },
          renewal: {
            auto: "Automática",
            pix: "Manual (Pix)",
            savedCard: "No cartão, com aviso 5 dias antes",
            none: "Não renova",
            label: "Renovação",
          },
          methodPix: "Pix",
          methodRecurring: "cartão recorrente",
          methodInstallments: "{{n}}x no cartão",
          methodCardOnce: "à vista no cartão",
          plan: "Plano",
          periodicity: "Periodicidade",
          cycle: "Ciclo atual",
          nextCharge: "Próxima cobrança",
          paymentMethod: "Meio de pagamento",
          accessUntil: "Acesso até",
          cycleRange: "{{start}} → {{end}}",
          nextChargeValue: "{{date}} · {{value}}",
          cardMasked: "{{brand}} •••• {{last4}}",
          cardOnFile: "Cartão",
          pendingPlan: "Muda para {{plan}} em {{date}}",
          pendingPeriod: "Muda para {{period}} em {{date}}",
          actions: {
            changePlan: "Mudar de plano",
            toMonthly: "Trocar para mensal",
            toYearly: "Trocar para anual",
            changeCard: "Trocar cartão",
            cancel: "Cancelar assinatura",
            payInvoice: "Pagar fatura · {{value}}",
            checkPayment: "Já paguei · verificar pagamento",
            subscribe: "Contratar plano",
          },
          rulesNote: "Troca de periodicidade e downgrade valem no próximo ciclo. Upgrade cobra só a diferença dos dias restantes e vale assim que for pago. Cancelamento mantém o acesso até {{date}}.",
          canceledNote: "Assinatura cancelada. O acesso continua até {{date}} e nada mais será cobrado.",
          pendingNote: "Aguardando a confirmação do pagamento da contratação.",
          pastDueNote: "A renovação não foi paga. Pague a fatura para não perder o acesso.",
          upgradePendingNote: "Upgrade aguardando pagamento ({{value}}). O plano novo vale assim que for pago.",
          empty: "Sua empresa ainda não tem assinatura. Contrate um plano com cartão ou Pix.",
          loadError: "Não foi possível carregar a assinatura.",
          renewalFailed: "Não conseguimos cobrar a renovação da assinatura. Pague a fatura em Assinatura para não perder o acesso.",
        },
        manage: {
          cancelTitle: "Cancelar assinatura",
          cancelBody: "A assinatura não será renovada. Você continua usando o sistema normalmente até {{date}}; depois disso o acesso é suspenso.",
          cancelInvoices: "Faturas em aberto desta assinatura também são canceladas.",
          cancelConfirm: "Cancelar assinatura",
          cancelKeep: "Manter assinatura",
          canceled: "Assinatura cancelada. O acesso continua até {{date}}.",
          periodTitle: "Trocar periodicidade",
          periodSubtitle: "{{plan}} · vale a partir do próximo ciclo",
          periodNoticePix: "Vale no próximo ciclo, a partir de {{date}}. A próxima fatura Pix já vem no novo período.",
          periodNoticeCardYearly: "Vale no próximo ciclo, a partir de {{date}}. A primeira cobrança anual será feita no checkout (cartão ou Pix).",
          periodNoticeCardMonthly: "Vale no próximo ciclo, a partir de {{date}}. A primeira cobrança mensal será feita no checkout (cartão ou Pix).",
          periodUndo: "A troca agendada é desfeita e a assinatura continua como está.",
          periodConfirm: "Confirmar troca",
          periodChanged: "Troca de periodicidade agendada para {{date}}.",
          periodUndone: "Troca de periodicidade desfeita.",
          cardTitle: "Trocar cartão",
          cardSubtitle: "Nenhuma cobrança é feita agora",
          cardNotice: "O novo cartão passa a ser usado nas próximas cobranças. O valor do formulário é só o do ciclo atual, para validar o cartão: nada é cobrado agora.",
          cardSubmit: "Salvar cartão",
          cardChanged: "Cartão atualizado.",
          cardUnavailable: "Troca de cartão indisponível no momento. Tente de novo mais tarde.",
          planTitle: "Mudar de plano",
          planSubtitle: "Preços no período atual ({{period}})",
          planListLabel: "Planos disponíveis",
          planCurrent: "Atual",
          planScheduled: "Agendado",
          planLimits: "{{users}} usuários · {{connections}} conexões · {{queues}} filas",
          planUpgrade: "Upgrade: cobramos agora só a diferença proporcional aos dias que faltam no ciclo. O plano novo vale assim que o pagamento for confirmado.",
          planUpgradeCard: "A cobrança vai no cartão {{card}}.",
          planUpgradePix: "Vamos gerar um Pix com o valor da diferença.",
          planDowngrade: "Downgrade: vale a partir do próximo ciclo, em {{date}}. Até lá você continua no plano atual.",
          planUndo: "O downgrade agendado é desfeito; você continua no plano atual.",
          planConfirm: "Confirmar troca",
          planNoOthers: "Não há outros planos disponíveis neste período.",
          planDowngradeScheduled: "Downgrade agendado para {{date}}.",
          planUndone: "Downgrade desfeito.",
          planChanged: "Plano alterado.",
          planUpgradePaid: "Upgrade pago. O plano novo já está valendo.",
          planUpgradeReview: "Pagamento do upgrade em análise. O plano muda assim que for aprovado.",
          planUpgradeOpen: "Não conseguimos cobrar o upgrade no cartão. Pague a fatura do upgrade na lista de faturas.",
          planPixTitle: "Pague o upgrade com Pix",
          planPixValue: "Diferença proporcional: {{value}}",
          close: "Fechar",
        },
      },
      backendErrors: {
        ERR_PROMPT_WHATSAPP_REQUIRED: "Escolha a conexão do agente.",
        ERR_PROMPT_QUEUE_OR_PREQUEUE_REQUIRED: "Escolha ao menos uma fila ou marque “Atender também antes da distribuição”.",
        ERR_PROMPT_QUEUE_NOT_IN_WHATSAPP: "Uma das filas escolhidas não pertence a esta conexão. Remova-a e salve de novo.",
        ERR_PROMPT_QUEUE_CONFLICT: "Uma das filas já tem outro agente nesta conexão. Cada fila tem no máximo um agente por conexão.",
        ERR_PROMPT_PREQUEUE_CONFLICT: "Outro agente já atende antes da distribuição nesta conexão. Desmarque a opção ou altere o outro agente.",
        ERR_SUB_ALREADY_ACTIVE: "Sua empresa já tem uma assinatura ativa.",
        ERR_SUB_PENDING_IN_PROGRESS: "Já existe uma contratação em andamento. Aguarde alguns instantes e tente de novo.",
        ERR_SUB_INVOICE_JUST_PAID: "Esta fatura acabou de ser paga. Atualize a página.",
        ERR_SUB_CARD_REJECTED: "Cartão recusado. Confira os dados ou use outro cartão.",
        ERR_SUB_INVALID_COMBINATION: "Essa combinação de período e forma de pagamento não está disponível para o plano.",
        ERR_SUB_INVALID_PERIOD: "Período inválido para este plano.",
        ERR_SUB_CARD_TOKEN_REQUIRED: "Preencha os dados do cartão.",
        ERR_SUB_PAYMENT_METHOD_REQUIRED: "Não identificamos a bandeira do cartão. Confira o número.",
        ERR_SUB_ALREADY_RECURRING: "Esta assinatura já tem cobrança automática no cartão. Aguarde a próxima tentativa ou pague com Pix.",
        ERR_SUB_PREVIOUS_PREAPPROVAL: "Não foi possível encerrar a tentativa anterior no Mercado Pago. Tente de novo em instantes.",
        ERR_SUB_NOT_FOUND: "Assinatura não encontrada.",
        ERR_SUB_NO_CARD: "Esta assinatura não tem cartão cadastrado.",
        ERR_SUB_NO_RECURRING: "Esta assinatura não tem cobrança automática no cartão.",
        ERR_SUB_SAME_PERIOD: "A assinatura já está nesse período.",
        ERR_SUB_SAME_PLAN: "A assinatura já está nesse plano.",
        ERR_SUB_UPGRADE_PENDING: "Há um upgrade aguardando pagamento. Pague a fatura dele antes de outra troca.",
        ERR_SUB_NEXT_CYCLE_INVOICE_OPEN: "A fatura do próximo ciclo já foi emitida. Pague-a antes de mudar a assinatura.",
        ERR_SUB_INVALID_ACTION: "Ação inválida para a assinatura.",
        ERR_INVOICE_NOT_FOUND: "Fatura não encontrada.",
        ERR_INVOICE_NOT_OPEN: "Esta fatura não está mais em aberto.",
        ERR_NO_PLAN_FOUND: "Sua empresa não tem plano definido. Fale com o suporte.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CAMPAIGN_TEST_NUMBER: "Informe um número válido com DDI e DDD para o teste.",
        ERR_CAMPAIGN_TEST_MESSAGE: "Escreva a mensagem 1 antes de testar.",
        ERR_CAMPAIGN_TEST_OFICIAL: "O teste rápido não está disponível na conexão oficial. Salve a campanha para uma lista de teste.",
        ERR_CAMPAIGN_TEST_TEMPLATE: "Selecione um template aprovado antes de testar na conexão oficial.",
        ERR_SMS_ROTA_INDISPONIVEL: "A rota de SMS escolhida não está disponível. Escolha outra rota na campanha.",
        ERR_SMS_ROTA_APOS_ENVIO: "Não é possível trocar a rota de uma campanha que já começou a enviar.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_2FA_ALREADY_ENABLED: "A autenticação de dois fatores já está ativada.",
        ERR_2FA_NOT_ENABLED: "A autenticação de dois fatores não está ativada.",
        ERR_2FA_INVALID_TOKEN: "Código de verificação inválido.",
        ERR_2FA_SESSION_EXPIRED: "Sessão de verificação expirada. Faça login novamente.",
        ERR_2FA_INVALID_SESSION: "Sessão de verificação inválida.",
        ERR_2FA_NOT_SETUP: "A autenticação de dois fatores não foi configurada.",
        ERR_2FA_PASSWORD_REQUIRED: "Senha é obrigatória para desativar a autenticação de dois fatores.",
        ERR_COMPANY_MANAGED_BY_SUBSCRIPTION: "Esta empresa tem assinatura ativa: plano, vencimento e recorrência são geridos por ela. Cancele a assinatura para editá-los.",
        ERR_PASSWORD_RESET_INVALID_CODE: "Código inválido ou expirado.",
        ERR_PASSWORD_RESET_SESSION_EXPIRED: "A sessão de redefinição expirou. Comece de novo.",
        ERR_PASSWORD_RESET_ALREADY_USED: "Este pedido de redefinição já foi usado. Comece de novo.",
        ERR_PASSWORD_RESET_INVALID_TOTP: "Código do autenticador inválido.",
        ERR_PASSWORD_RESET_TOO_MANY_REQUESTS: "Muitos pedidos. Espere um minuto e tente de novo.",
        ERR_PASSWORD_RESET_WEAK_PASSWORD: "A senha precisa ter pelo menos 5 caracteres.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        headerOrigin:
          'X-Origin (obrigatório): nome do sistema que está chamando, até 80 caracteres (ex.: "ERP Financeiro"). Aparece como origem no relatório de uso da API em /reports/api',
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody:
          '"body": "Mensagem" (obrigatório sem templateName; com templateName é opcional e descartado)',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        fieldTemplateName:
          '"templateName": (opcional, conexão oficial) nome do template a enviar — vale dentro e fora da janela de 24h; com ele o body é descartado e o template é entregue',
        fieldTemplateParams:
          '"templateParams": (opcional) array de strings na ordem das variáveis; aceita {nome}, {numero}, {email}',
        fieldTemplateHeaderMediaUrl:
          '"templateHeaderMediaUrl": (obrigatório se o template tem mídia no cabeçalho) URL http(s) pública do arquivo',
        fieldTemplateOrderDetails:
          '"templateOrderDetails": (opcional, só com templateName) objeto order_details do template de cobrança Pix (ORDER_DETAILS): código copia-e-cola, valores em centavos ({ value, offset: 100 }); erro de formato responde 422 com a regra violada',
        fieldTemplateOrderDetailsExpiration:
          '"order.expiration": (opcional) timestamp em epoch de segundos, mínimo 5 min no futuro — expira o botão no card; alinhe à validade real do Pix gerado no PSP, que ela não controla',
        smsFieldNumber:
          '"number": "5531999999999" (obrigatório) — celular brasileiro: 55 + DDD + número; o que não for dígito é removido. Telefone fixo (55 + DDD + 8 dígitos começando em 2 a 5) é recusado com 400, sem débito',
        smsFieldBody:
          '"body": "Seu boleto vence amanhã. Pague em {link}" (obrigatório) — o marcador {link} é opcional e recebe o link encurtado',
        smsFieldLink:
          '"link": (opcional) objeto; exige {link} no body e vice-versa — informe url OU whatsappNumber, nunca os dois',
        smsFieldLinkUrl: '"link.url": "https://exemplo.com/boleto/123" — URL http/https',
        smsFieldLinkWhatsapp:
          '"link.whatsappNumber": "5531988887777" — só dígitos; abre conversa no WhatsApp',
        smsFieldLinkPrefilled:
          '"link.prefilledText": "Quero pagar" — (opcional) só junto com whatsappNumber',
        smsResponseSend:
          '200: { "id": 123, "status": "sent", "providerMessageId": "…", "parts": 2, "balance": 998 } — balance pode vir null se a leitura do saldo falhar; "debitPending": true só se o débito pós-envio falhar. 400 { "error": "…" }: X-Origin ausente, campo inválido, número fixo ("Número fixo não recebe SMS") ou não é celular, ou saldo insuficiente',
        smsResponseStatus:
          '200: { "id", "number", "status": "pending|sent|delivered|failed", "failureReason", "origin", "parts", "sentAt", "deliveredAt" } — sem confirmação do provedor em 24h (ou no prazo configurado pela empresa), "sent" vira "failed" com failureReason "Sem confirmação de entrega do provedor de SMS em 24h"; se o provedor confirmar depois, volta a "delivered". 404 { "error": "SMS não encontrado." }',
        smsResponseBalance:
          '200: { "balance": 998 } — créditos = partes de SMS (até 160 caracteres = 1 parte; acima disso, 153 por parte)',
        responseText: "200 (conexão oficial): { \"message\": \"Mensagem enviada com sucesso\", \"companyId\": 1, \"ticketId\": 215, \"messageId\": 4821, \"wid\": \"wamid.…\", \"status\": \"accepted\" } — accepted = aceita pela Meta; a entrega é assíncrona, consulte GET /api/messages/{messageId}/status. O texto de message não mudou e não garante entrega. \"warning\" { code, category, reason, action, link, reasonOriginal } só aparece se a conexão tem problema de conta. Conexão QR Code (Baileys): { \"message\": \"Mensagem enviada a fila de transmissão com sucesso\", \"companyId\", \"schedule\", \"filaId\" }, sem messageId (a mensagem nasce depois, pela fila). Se a Meta recusar na hora, volta erro HTTP (não 200) com o motivo traduzido em \"error\". Tipos: messageId = número | null e wid = texto | null. null significa que a mensagem foi aceita mas ainda não tem registro consultável: mantenha o ticketId e não consulte o status (só consulte quando messageId não for null).",
        responseMedia: "200 (conexão oficial): { \"status\": \"SUCCESS\", \"messageId\": 4822, \"messageIds\": [4822], \"wid\": \"wamid.…\" } — SUCCESS é o contrato antigo e só indica aceita pela Meta; a entrega é assíncrona. messageId = primeiro arquivo; messageIds = um id por arquivo, na ordem de envio; consulte cada um em GET /api/messages/{messageId}/status. \"warning\" só com problema de conta na conexão. Conexão QR Code (Baileys): { \"status\": \"SUCCESS\" }, sem messageId. Tipos: messageId = número | null, messageIds = lista de número | null, wid = texto | null. null = aceita, sem registro consultável: ignore os nulos e não consulte o status deles.",
        statusResponse: "200: { \"messageId\": 4821, \"wid\": \"wamid.…\", \"status\": \"accepted|sent|delivered|read|failed\", \"ack\": -1, \"failure\": { \"code\": 131042, \"category\": \"conta\", \"reason\": \"…\", \"action\": \"…\", \"link\": \"…\", \"reasonOriginal\": \"…\" } } — failure é null enquanto a mensagem não falhou (ack: 0/1 enviada, 2 entregue, 3 lida, -1 = falhou). A Meta confirma a entrega depois: a mensagem pode ficar um tempo em accepted/sent. Nada é reenviado automaticamente. 404 { \"error\": \"ERR_NO_MESSAGE_FOUND\" }: id inexistente, de outra empresa ou de outra conexão (o token só enxerga mensagens enviadas pela própria conexão). 402 ERR_LICENSE_EXPIRED: licença vencida",
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel ao Vivo",
        subtitle: "Atendimentos em andamento por atendente",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
        searchPlaceholder: "Buscar contato…",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        deletedAdminShort: "Visível para admin",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        copy: "Copiar",
        copied: "Mensagem copiada.",
        react: "Reagir",
        linkTicket: "Vincular ticket",
        ticketNumber: "Nº do ticket",
        ticketNotFound: "Ticket não encontrado.",
        attachTicket: "Anexar à mensagem",
        openTicket: "Abrir atendimento",
        editMessage: "Editar mensagem",
        editTimeLeft: "Restam {{min}} min para editar",
        editHint: "A mensagem ficará marcada como \"editada\" para todos.",
        editedLabel: "editada",
        forwardedLabel: "Encaminhada",
        forwardMessage: "Encaminhar mensagem",
        forwardSubtitle: "Escolha uma ou mais conversas",
        forwardedTo: "Encaminhada para {{count}} conversa(s).",
        selectedCount: "{{count}} selecionada(s)",
        deleteTitle: "Apagar mensagem?",
        deleteText: "Ela será substituída por \"Esta mensagem foi apagada\" para todos. Administradores ainda conseguem ver o conteúdo original.",
        deleteConfirm: "Apagar",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
        message: "Mensagem",
        document: "Documento",
        readyToSend: "pronto para enviar",
        placeholderGroup: "Mensagem para o grupo…",
        placeholderDm: "Mensagem…",
        save: "Salvar",
        cancel: "Cancelar",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        title: "Chat Interno",
        new: "Nova",
        markAllRead: "Marcar tudo como lido",
        search: "Buscar conversa ou pessoa…",
        filters: { all: "Todas", unread: "Não lidas", groups: "Grupos" },
        noChats: "Nenhuma conversa encontrada",
        selectChat: "Escolha uma conversa ou crie uma nova",
        participants: "{{count}} participantes",
        online: "{{count}} online",
        onlineNow: "Online",
        offline: "Offline",
        searchInChat: "Buscar na conversa",
        searchInChatPlaceholder: "Buscar nas mensagens carregadas…",
        editGroup: "Editar grupo",
        chats: "Chats",
        groups: "Grupos",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        menu: {
          section: "Conversa",
          details: "Detalhes do grupo",
          detailsDm: "Detalhes da conversa",
          edit: "Editar grupo",
          mute: "Silenciar",
          unmute: "Reativar notificações",
          markRead: "Marcar como lido",
          leave: "Sair do grupo",
          delete: "Excluir conversa",
        },
        info: {
          createdBy: "Criado por {{name}}",
          members: "Participantes · {{count}}",
          add: "Adicionar",
        },
        deleteChat: {
          title: "Excluir esta conversa?",
          groupBefore: "O grupo",
          dmBefore: "A conversa com",
          middle: "e suas",
          messages: "{{count}} mensagens",
          after: "serão removidos para todos os {{count}} participantes.",
          confirm: "Excluir para todos",
        },
        leave: {
          title: "Sair de {{name}}?",
          text: "Você deixa de receber as mensagens deste grupo. Um administrador pode adicionar você de novo.",
          confirm: "Sair do grupo",
        },
        toasts: {
          chatDeleted: "Conversa excluída.",
          left: "Você saiu do grupo.",
          muted: "Conversa silenciada.",
          unmuted: "Notificações reativadas.",
          mentioned: "{{name}} mencionou você em {{chat}}. Clique para abrir.",
        },
        modal: {
          title: "Nova conversa",
          editTitle: "Editar grupo",
          subtitle: "Converse com um colega ou crie um grupo da equipe",
          subtitleDirect: "Escolha um colega para conversar",
          editSubtitle: "Nome e participantes do grupo",
          direct: "Direta",
          group: "Grupo",
          name: "Nome do grupo",
          namePlaceholder: "Ex.: Suporte N1 — turno da tarde",
          nameRequired: "Informe o nome do grupo.",
          membersRequired: "Escolha ao menos um participante.",
          members: "Participantes",
          selected: "{{count}} selecionados",
          addQueue: "Adicionar toda a fila {{queue}}",
          searchPerson: "Buscar pessoa…",
          onlineSection: "Online",
          offlineSection: "Offline",
          existing: "Conversa existente",
          directHint: "Se já existir uma conversa com a pessoa, ela será aberta.",
          create: "Criar grupo",
          save: "Salvar alterações",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
      twoFactor: {
        setup: {
          title: "Autenticação de Dois Fatores (2FA)",
          description: "Adicione uma camada extra de segurança à sua conta usando um aplicativo autenticador como Google Authenticator ou Authy.",
          enable: "Ativar 2FA",
          manage: "Gerenciar 2FA",
          statusEnabled: "A autenticação de dois fatores está ativada na sua conta.",
          statusDisabled: "A autenticação de dois fatores não está ativada.",
          activate: "Ativar",
          deactivate: "Desativar 2FA",
          adminDeactivate: "Desativar 2FA (Admin)",
          passwordConfirm: "Confirme sua senha",
          scanQR: "Escaneie o QR code abaixo com seu aplicativo autenticador:",
          manualEntry: "Ou digite o código manualmente:",
          verifyCode: "Código de verificação",
          verifyAndActivate: "Verificar e Ativar",
          invalidCode: "Código inválido. Digite os 6 dígitos do seu app.",
          recoveryTitle: "Códigos de Recuperação",
          recoveryWarning: "Guarde estes códigos em um lugar seguro. Cada código só pode ser usado uma vez. Estes códigos não serão exibidos novamente.",
          copyCodes: "Copiar Códigos",
          codesCopied: "Códigos copiados!",
          confirmSaved: "Confirmo que salvei os códigos de recuperação",
          done: "Concluir",
          close: "Fechar",
          disabled: "2FA desativado com sucesso",
          mandatoryMessage: "Sua organização exige autenticação de dois fatores. Configure agora para continuar.",
          setupComplete: "2FA configurado com sucesso! Você será redirecionado automaticamente.",
        },
        policy: {
          label: "Política de 2FA",
          optional: "Opcional",
          mandatory: "Obrigatório",
          disabled: "Desativado",
        },
      },
    },
  },
};

export { messages };
